export { default } from './PageDictionaries.vue'
